import { Modal } from 'antd';
import React, { useEffect, useState, useCallback } from 'react';
import styles from './BtnGroup.less?modules';
import dayjs from 'dayjs';
import { useDispatch, useSelector } from 'dva';
import DataTable from '@/containers/data_table_ml/DataTable';
import ButtonML from '@/components/button_ml/ButtonML';
import { history } from 'umi';
import './BtnGroup.less';

const BtnGroup = (props) => {
  const { id, name, handleSave, handleCancel } = props || {};
  const { editable } = props.location.query;

  const [show, setShow] = useState(false);
  const dispatch = useDispatch();
  // 发起请求
  const fetchData = useCallback(() => {
    dispatch({
      type: 'tvfConditionDetail/getHandleList',
      payload: {
        values: {
          fieldId: id,
        },
      },
    });
  }, [dispatch, id]);
  useEffect(() => {
    fetchData();
  }, [fetchData]);
  const loadingEffect = useSelector((state) => state.loading);
  const loading = loadingEffect.effects['tvfConditionDetail/getHandleList'];
  const data =
    useSelector((state) => state.tvfConditionDetail.getHandleList) || [];
  const handleHandle = () => {
    fetchData();
    //进入三级目录规则详情
    // history.push({
    //   pathname: '/bre/fm/tvf/cfg/c_handle_detail',
    //   query: { id: id },
    // });
    setShow(true);
  };
  const handleTest = () => {
    //进入三级目录单元测试
    history.push({
      pathname: '/bre/fm/tvf/cfg/c_unit_test',
      query: { id: id, name: name },
    });
  };

  const columns = [
    {
      title: 'ID',
      dataIndex: 'id',
      key: 'id',
      width: 50,
    },
    {
      title: '操作人员',
      dataIndex: 'owner',
      key: 'owner',
      width: 200,
    },
    {
      title: '操作时间',
      dataIndex: 'updateTime',
      key: 'updateTime',
      width: 200,
      render: (text) => (
        <span>{dayjs(text).format('YYYY-MM-DD HH:mm:ss')}</span>
      ),
    },
    {
      title: '操作前',
      dataIndex: 'operatorBefore',
      key: 'operatorBefore',
      width: 300,
    },
    {
      title: '操作后',
      dataIndex: 'operatorAfter',
      key: 'operatorAfter',
      width: 300,
    },
  ];
  return (
    <>
      <div className={styles.btn_contain}>
        <ButtonML
          size="large"
          value="保存"
          fontsize="16px"
          onClick={() => handleSave()}
          disabled={String(editable) === 'false'}
        />
        <ButtonML
          size="large"
          value="单元测试"
          fontsize="16px"
          onClick={() => handleTest()}
        />
        <ButtonML
          size="large"
          value="取消"
          fontsize="16px"
          onClick={() => handleCancel()}
        />
        <ButtonML
          size="large"
          value="操作日志"
          fontsize="16px"
          onClick={() => {
            handleHandle();
          }}
        />
        <ButtonML
          size="large"
          value="返回"
          // width="106px"
          // height="46px"
          fontsize="16px"
          onClick={() => history.go(-1)}
        />
      </div>
      <Modal
        title="操作日志"
        visible={show}
        onCancel={() => setShow(false)}
        footer={null}
        className="id_detail"
      >
        <DataTable
          border={true}
          className="demo-test"
          // style={{ minWidth: '1547px', border: '1px solid #edf0f0' }}
          columns={columns}
          rowSelection={false}
          scroll={{ y: 'calc(80vh - 160px)' }}
          dataSource={data}
          loading={loading}
        />
      </Modal>
    </>
  );
};

export default BtnGroup;
